// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KidStories_kidStoriesContainer__W3KYM {
  color: white;
  padding-bottom: 2rem;
}

.KidStories_sectionHeader__\\+SSpB {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 1.5rem auto;
}

.KidStories_title__JeARu {
  font-size: 1.5rem;
  font-weight: 500;
}

.KidStories_viewAll__Ocbdz {
  color: white;
  text-decoration: none;
  font-size: 0.9rem;
  opacity: 0.8;
}

.KidStories_cardGrid__l2sTy {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  max-width: 1200px;
  margin: 0 auto;
}

.KidStories_cardContainer__7WeGK {
  background-color: #242424;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.2s;
}

.KidStories_cardContainer__7WeGK:hover {
  transform: translateY(-5px);
}

.KidStories_thumbnailContainer__6zmMc {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  overflow: hidden;
  cursor: pointer;
}

.KidStories_channelName__kblgn{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1; /* Limit to 3 lines */
}

.KidStories_thumbnail__qpOAr {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 9px;
  transition: transform 0.3s ease;
}

/* Play button hover effect styles */
.KidStories_playButtonOverlay__Ue7d\\+ {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease;
}

.KidStories_playButtonOverlay__Ue7d\\+:hover {
  background-color: rgba(0, 0, 0, 0.4);
}

.KidStories_playButton__vXDVt {
  display: flex;
  justify-content: center;
  align-items: center;
}

.KidStories_thumbnailContainer__6zmMc:hover .KidStories_thumbnail__qpOAr {
  transform: scale(1.05);
}
/* End of play button hover effect styles */

.KidStories_cardContent__o8UcQ {
  padding: 1rem;
}
.KidStories_pageTitle__9WFor{
  font-size: 1.5rem !important;
}
.KidStories_title__JeARu {
  font-size: 1rem;
  margin: 0 0 0.5rem 0;
  font-weight: 500;
  -webkit-line-clamp: 1; /* Limit to 3 lines */
  white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.KidStories_metaInfo__95voB {
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  color: #999;
  margin-bottom: 0.5rem;
}
.KidStories_fullPageTitle__Tqefn{
  font-size: 2rem !important;
  padding-top: 4rem;
}
.KidStories_dot__qBEja {
  margin: 0 0.5rem;
}
.KidStories_description__f5c1I {
  font-size: 0.9rem;
  color: #999;
  margin-bottom: 1rem;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* Limit to 3 lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}
.KidStories_youtubeIcon__2It9s {
  vertical-align: middle;
  margin-right: 4px;
  width: 20px !important;
  height: 20px !important;
  color: #ff0000;
}
.KidStories_watchButton__Rg03P {
  background-color: #ff0000;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.KidStories_watchButton__Rg03P:hover {
  background-color: #cc0000;
}
.KidStories_icon__EhKnY {
  width: 16px;
  height: 16px;
  color: #000;
  border-radius: 50%;
  background-color: #fff;
  padding: 5px;
}
.KidStories_sliderContainer__ijg0N{
  max-width: 1200px;
  margin: auto;
}

@media (max-width: 1024px) {
  .KidStories_cardGrid__l2sTy {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .KidStories_cardGrid__l2sTy {
    grid-template-columns: repeat(2, 1fr);
  }
  .KidStories_kidStoriesContainer__W3KYM{
    padding-top: 6rem !important;
  }
}

@media (max-width: 480px) {
  .KidStories_cardGrid__l2sTy {
    grid-template-columns: 1fr;
  }
  .KidStories_kidStoriesContainer__W3KYM{
    padding: 2rem !important;
  }
  .KidStories_title__JeARu {
    font-size: 12px;
  }
  .KidStories_metaInfo__95voB {
    font-size: 7px;
  }
  .KidStories_youtubeIcon__2It9s svg{
    width: 20px !important;
    height: 20px !important;
  }
  .KidStories_description__f5c1I {
    font-size: 7px;
  }
  .KidStories_watchButton__Rg03P {
    font-size: 8px;
    padding: 0.2rem 0.5rem;
  }
  .KidStories_icon__EhKnY {
    width: 10px;
    height: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/video-pages/css/KidStories.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB,EAAE,sBAAsB;EAC3C,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB,EAAE,qBAAqB;AAC9C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;AACA,2CAA2C;;AAE3C;EACE,aAAa;AACf;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB,EAAE,qBAAqB;EAC5C,mBAAmB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB,EAAE,qBAAqB;EAC5C,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".kidStoriesContainer {\n  color: white;\n  padding-bottom: 2rem;\n}\n\n.sectionHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1200px;\n  margin: 1.5rem auto;\n}\n\n.title {\n  font-size: 1.5rem;\n  font-weight: 500;\n}\n\n.viewAll {\n  color: white;\n  text-decoration: none;\n  font-size: 0.9rem;\n  opacity: 0.8;\n}\n\n.cardGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1.5rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.cardContainer {\n  background-color: #242424;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: transform 0.2s;\n}\n\n.cardContainer:hover {\n  transform: translateY(-5px);\n}\n\n.thumbnailContainer {\n  position: relative;\n  width: 100%;\n  padding-top: 56.25%; /* 16:9 Aspect Ratio */\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.channelName{\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 1; /* Limit to 3 lines */\n}\n\n.thumbnail {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 9px;\n  transition: transform 0.3s ease;\n}\n\n/* Play button hover effect styles */\n.playButtonOverlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.2);\n  transition: background-color 0.3s ease;\n}\n\n.playButtonOverlay:hover {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n.playButton {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.thumbnailContainer:hover .thumbnail {\n  transform: scale(1.05);\n}\n/* End of play button hover effect styles */\n\n.cardContent {\n  padding: 1rem;\n}\n.pageTitle{\n  font-size: 1.5rem !important;\n}\n.title {\n  font-size: 1rem;\n  margin: 0 0 0.5rem 0;\n  font-weight: 500;\n  -webkit-line-clamp: 1; /* Limit to 3 lines */\n  white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.metaInfo {\n  display: flex;\n  align-items: center;\n  font-size: 0.8rem;\n  color: #999;\n  margin-bottom: 0.5rem;\n}\n.fullPageTitle{\n  font-size: 2rem !important;\n  padding-top: 4rem;\n}\n.dot {\n  margin: 0 0.5rem;\n}\n.description {\n  font-size: 0.9rem;\n  color: #999;\n  margin-bottom: 1rem;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 3; /* Limit to 3 lines */\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: normal;\n}\n.youtubeIcon {\n  vertical-align: middle;\n  margin-right: 4px;\n  width: 20px !important;\n  height: 20px !important;\n  color: #ff0000;\n}\n.watchButton {\n  background-color: #ff0000;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.watchButton:hover {\n  background-color: #cc0000;\n}\n.icon {\n  width: 16px;\n  height: 16px;\n  color: #000;\n  border-radius: 50%;\n  background-color: #fff;\n  padding: 5px;\n}\n.sliderContainer{\n  max-width: 1200px;\n  margin: auto;\n}\n\n@media (max-width: 1024px) {\n  .cardGrid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .cardGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .kidStoriesContainer{\n    padding-top: 6rem !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .cardGrid {\n    grid-template-columns: 1fr;\n  }\n  .kidStoriesContainer{\n    padding: 2rem !important;\n  }\n  .title {\n    font-size: 12px;\n  }\n  .metaInfo {\n    font-size: 7px;\n  }\n  .youtubeIcon svg{\n    width: 20px !important;\n    height: 20px !important;\n  }\n  .description {\n    font-size: 7px;\n  }\n  .watchButton {\n    font-size: 8px;\n    padding: 0.2rem 0.5rem;\n  }\n  .icon {\n    width: 10px;\n    height: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"kidStoriesContainer": `KidStories_kidStoriesContainer__W3KYM`,
	"sectionHeader": `KidStories_sectionHeader__+SSpB`,
	"title": `KidStories_title__JeARu`,
	"viewAll": `KidStories_viewAll__Ocbdz`,
	"cardGrid": `KidStories_cardGrid__l2sTy`,
	"cardContainer": `KidStories_cardContainer__7WeGK`,
	"thumbnailContainer": `KidStories_thumbnailContainer__6zmMc`,
	"channelName": `KidStories_channelName__kblgn`,
	"thumbnail": `KidStories_thumbnail__qpOAr`,
	"playButtonOverlay": `KidStories_playButtonOverlay__Ue7d+`,
	"playButton": `KidStories_playButton__vXDVt`,
	"cardContent": `KidStories_cardContent__o8UcQ`,
	"pageTitle": `KidStories_pageTitle__9WFor`,
	"metaInfo": `KidStories_metaInfo__95voB`,
	"fullPageTitle": `KidStories_fullPageTitle__Tqefn`,
	"dot": `KidStories_dot__qBEja`,
	"description": `KidStories_description__f5c1I`,
	"youtubeIcon": `KidStories_youtubeIcon__2It9s`,
	"watchButton": `KidStories_watchButton__Rg03P`,
	"icon": `KidStories_icon__EhKnY`,
	"sliderContainer": `KidStories_sliderContainer__ijg0N`
};
export default ___CSS_LOADER_EXPORT___;
